const CardFunComponent = () => import('@/views/card/CardFun/CardFunView')

export default [
    {
        path:'/CardFunIndex',
        name:'CardFunRouter',
        component:CardFunComponent
    }
]